// GA4 event tracking utility (Measurement ID: G-THGWZL7KWH)

export function trackEvent(eventName, params = {}) {
  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }
}

// Pre-defined conversion events
export const GA = {
  pageView: (page) => trackEvent("page_view", { page_title: page }),
  chatStarted: () => trackEvent("chat_started", { value: 1 }),
  paymentInitiated: (amount) => trackEvent("payment_initiated", { currency: "INR", value: amount }),
  paymentSuccess: (amount, orderId) => trackEvent("purchase", { currency: "INR", value: amount, transaction_id: orderId }),
  rechargeInitiated: () => trackEvent("recharge_initiated", { value: 1 }),
  rechargeSuccess: () => trackEvent("recharge_success", { value: 1 }),
};
